import { render, staticRenderFns } from "./ScreenConfigureBoards.vue?vue&type=template&id=6b4ed0d2&scoped=true"
import script from "./ScreenConfigureBoards.vue?vue&type=script&lang=js"
export * from "./ScreenConfigureBoards.vue?vue&type=script&lang=js"
import style0 from "./ScreenConfigureBoards.vue?vue&type=style&index=0&id=6b4ed0d2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b4ed0d2",
  null
  
)

export default component.exports